import { useState } from "react";

/**
 *
 * @param {string} endpoint The Basin form endpoint to submit to
 * @returns {array}         The state of the form, and the submit function.
 */
function useBasin(endpoint) {
  // Ensure the endpoint passed in is a valid Basin endpoint.
  if (!/https:\/\/usebasin.com\/f\/[a-zA-Z0-9_]*$/g.test(endpoint))
    throw new Error(
      `Invalid Basin endpoint passed to useBasin hook. Must be in this format: https://usebasin.com/f/<form id>`
    );

  const [state, setState] = useState({
    submitted: false,
    pending: false,
    error: false,
  });

  const submit = async (e) => {
    setState({
      submitted: false,
      pending: true,
      error: false,
    });

    const form = e.target.closest("form");
    const data = new FormData(form);
    data && console.log("Form Data: ", data);
    const headers = new Headers({
      Accept: "application/json",
    });

    const options = {
      method: "POST",
      body: data,
      headers,
    };

    console.log(options);

    const response = await fetch(endpoint, options);

    if (response) console.log(response);

    setState({
      submitted: response.ok,
      error: !response.ok,
      pending: false,
    });

    return !response.ok;
  };

  return [state, submit];
}

export default useBasin;
